export const setSessionStorageItem = <T>(key: string, value: T) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

import { parseJson } from './common';

export const getSessionStorageItem = <T>(key: string): T | null => {
  const storedValue = sessionStorage.getItem(key);
  if (storedValue) {
    return parseJson(storedValue, null) as T | null;
  }
  return null;
};

export const clearSessionStorageFlag = (key: string) => {
  sessionStorage.removeItem(key);
};
